export enum AggregationLevel {
  HIGHEST = 'highest',
  CUSTOM = 'custom',
}
